import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { Col, Divider, Radio, RadioChangeEvent, Row, Space } from 'antd'
import { PrimaryButton } from 'Components/button'
import { formValidation, getCustomerTaxMenuSelect, isFormError, isFormRequired } from 'helpers/format'
import { DetailReq } from 'Store/orders/types'
import { getOrderDetailAPI } from 'Store/orders/api'
import { selectDetail, selectDetailEvent } from 'Store/orders/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { clearEventAction } from 'Store/tax-management/actions'
import EventModal from 'Components/modal/EventModal'
import LoadingView from 'Components/modal/LoadingView'
import { DetailDrawer } from 'Components/common/MainLayout'
import { ConfirmDailog } from 'Components/modal'
import { DeliveryInfo, PaymentInfo, ProductsInfo, ReciverInfo } from '../../Orders/components'
import { menuVatType, OrderStatus, VAT_TYPE } from 'helpers/constanst'
import { AppInput, AppSelect } from 'Components/form'
import { CreateTaxReq } from 'Store/tax-management/types'
import { cloneDeep } from 'lodash'
import { createTaxAPI } from 'Store/tax-management/api'
import { selectAllCustomerTax, selectTaxActionEvent } from 'Store/tax-management/selector'
import CustomerSummayTax from './CustomerSummayTax'
import { ReturnListReq } from 'Store/return-order/types'
import { returnListAPI } from 'Store/return-order/api'
import { selectReturnList } from 'Store/return-order/selector'

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  onSuccess?: () => void
  orderNo?: string
  status: OrderStatus
}

const CreateTax: React.FunctionComponent<Props> = props => {
  const {
    onCloseDrawer,
    visible,
    currentUser,
    event,
    onSuccess = () => {},
    orderNo = '',
    detail,
    status,
    detailEvent,
    customers,
    returnList,
  } = props

  const initForm = {
    address: '',
    mobile: '',
    name: '',
    tax_payer_no: '',
    order_no: orderNo,
    note: '',
    vat_amount: 7,
  } as CreateTaxReq
  const [formData, setFormData] = useState(cloneDeep(initForm))
  const [formError, setFormError] = useState([] as string[])
  const [customerType, setCustomerType] = useState(1 as number)
  const requireFeild = ['address', 'name', 'tax_payer_no', 'vat_amount']
  const [confirmDialog, setConfirmDialog] = useState(false)
  const hasProduct =
    detail?.products && detail?.products[0].products?.find(item => item?.product?.refund_status !== 'Y')

  let returnPrice = 0
  returnList &&
    returnList?.data?.forEach(item => {
      returnPrice += item.total_amount
    })
  const dispatch = useDispatch()

  useEffect(() => {
    if (visible && orderNo !== '') {
      onGetDetail()
      //onGetAllCustomerTax()
      setFormData(cloneDeep(initForm))
      setFormError([])
      setCustomerType(1)
    }
  }, [visible])

  useEffect(() => {
    if (formError.length > 0) {
      validateForm()
    }
  }, [formData])

  useEffect(() => {
    if (detail) {
      const vatDefault =
        detail?.payment_detail?.vat_type === VAT_TYPE.EX ? (detail?.payment_detail?.is_tax ? 7 : 100) : 7
      setFormData({
        ...formData,
        vat_amount: vatDefault,
      })
    }
  }, [detail])

  const onGetDetail = (): void => {
    if (orderNo == '') return
    const req: DetailReq = {
      order_no: orderNo,
    }
    dispatch(getOrderDetailAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  // const onGetAllCustomerTax = (): void => {
  //   const req: GetAllCustomerTaxReq = {}
  //   dispatch(getAllCustomertaxListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  // }

  const onCreate = (): void => {
    if (!validateForm()) return
    const req: CreateTaxReq = {
      ...formData,
      vat_amount: formData?.vat_amount === 100 ? 0 : formData?.vat_amount,
      //order_no: orderNo,
    }
    dispatch(createTaxAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || 0))
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    clearEvent()
    onSuccess()
    if (confirmDialog) {
      setConfirmDialog(false)
    }
  }

  useEffect(() => {
    if (visible && detail) {
      onGetReturnList()
    }
  }, [detail])

  const onGetReturnList = (): void => {
    const orderNo = detail?.order_no || ''
    const req: ReturnListReq = {
      keyword: orderNo,
      page: 1,
      per_page: 100,
      start_date: '',
      end_date: '',
      status: '',
    }
    dispatch(returnListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const FooterContent = (
    <Space>
      <PrimaryButton key={`cancel`} text="ยกเลิก" btnType="Cancel" onClick={onCloseDrawer} />
      <PrimaryButton
        key={`create`}
        text="สร้างใบกำกับภาษี"
        btnType="Primary"
        onClick={() => {
          if (!validateForm()) return
          setConfirmDialog(true)
        }}
        disabled={!hasProduct}
      />
    </Space>
  )

  const ConfirmCreateDailog = (
    <ConfirmDailog
      title="ยืนยันการสร้างใบกำกับภาษีเต็มรูปแบบ?"
      description={`หากยืนยันการสร้างแล้วจะไม่สามารถแก้ไขข้อมูลได้ กรุณาตรวจสอบความถูกต้องของคำสั่งซื้อ และข้อมูลลูกค้าก่อนกดยืนยัน`}
      confirmBtnTxt="ยืนยัน"
      isShow={confirmDialog}
      handleOk={onCreate}
      handleCancel={() => setConfirmDialog(false)}
      loading={event.IsLoading}
    />
  )

  const title = (
    <>
      <span> ออกใบกำกับภาษีรูปแบบเต็ม</span> <br />
      <InfoTitle>เลขที่สั่งซื้อ : {detail?.order_no}</InfoTitle>
    </>
  )

  const validateForm = () => {
    const error = formValidation(requireFeild, formData)
    if (formData.tax_payer_no && formData.tax_payer_no.length < 13) {
      error.push('tax_payer_no_format')
    }
    setFormError([...error])
    return error.length > 0 ? false : true
  }

  const onUpdateData = (val: string, key: string) => {
    if (key === 'tax_payer_no' && val.length > 13) {
      return
    }
    if (key === 'tax_payer_no') {
      if (customerType === 2) {
        setCustomerType(1)
      }
    }
    setFormData({
      ...formData,
      [key]: val,
    })
  }

  const isRequired = (name: string) => {
    return isFormRequired(requireFeild, name)
  }

  const isError = (name: string) => {
    return isFormError(formError, name)
  }

  const onChange = (e: RadioChangeEvent) => {
    if (customerType === 1) {
      setFormData({
        ...formData,
        name: '',
        address: '',
        mobile: '',
        tax_payer_no: '',
      })
    } else {
      setFormData({
        ...formData,
      })
    }
    setCustomerType(e.target.value)
  }

  const onSelectCustomer = (val: string) => {
    const result = customers && customers.find(item => item.taxpayer_no === val)
    setFormData({
      ...formData,
      address: result?.address || '',
      mobile: result?.mobile || '',
      name: result?.name || '',
      tax_payer_no: result?.taxpayer_no || '',
    })
  }

  const customerInfo = () => {
    return (
      <BoxWrapper>
        <BoxTitle>ข้อมูลลูกค้า</BoxTitle> <br />
        <Row justify="space-between" gutter={16}>
          <Col md={24} xs={24}>
            <Radio.Group onChange={onChange} value={customerType}>
              <Radio value={1}>ข้อมูลใหม่</Radio>
              <Radio value={2}>เคยมีข้อมูลแล้ว</Radio>
            </Radio.Group>
          </Col>
          <Divider />
          {customerType === 2 && (
            <Col md={24} xs={24}>
              <AppSelect
                name="tax_payer_no"
                label="เลือกลูกค้า/บริษัท"
                placeHolder="ค้นหาชื่อลูกค้า/บริษัท"
                isRequired={isRequired('tax_payer_no')}
                isError={isError('tax_payer_no')}
                value={formData?.tax_payer_no ? formData?.tax_payer_no : null}
                onChange={onSelectCustomer}
                menu={getCustomerTaxMenuSelect(customers, 'name', 'taxpayer_no')}
                allowClear={false}
              />
            </Col>
          )}
          <Col md={12} xs={24}>
            <AppInput
              name="name"
              label="ชื่อลูกค้า/ ชื่อบริษัท"
              placeHolder="ระบุชื่อลูกค้า/ ชื่อบริษัท"
              isRequired={isRequired('name')}
              isError={isError('name')}
              value={formData.name}
              onChange={onUpdateData}
              // resProps={{
              //   disabled: customerType === 2,
              // }}
            />
          </Col>

          <Col md={12} xs={24}>
            <AppInput
              name="tax_payer_no"
              label="เลขประจำตัวผู้เสียภาษี"
              errorMsg={
                isError('tax_payer_no_format')
                  ? 'รูปแบบเลขประจำตัวผู้เสียภาษีให้ถูกต้อง (13 หลัก)'
                  : 'เลขประจำตัวผู้เสียภาษี'
              }
              isRequired={isRequired('tax_payer_no')}
              isError={isError('tax_payer_no') || isError('tax_payer_no_format')}
              value={formData.tax_payer_no}
              onChange={onUpdateData}
              // resProps={{
              //   disabled: customerType === 2,
              // }}
            />
          </Col>
          <Col md={24} xs={24}>
            <AppInput
              label="ที่อยู่ตามบัตรประชาชน/ที่อยู่จดทะเบียนบริษัท"
              isRequired={isRequired('address')}
              isError={isError('address')}
              name="address"
              value={formData.address}
              onChange={onUpdateData}
            />
          </Col>
          <Col md={12} xs={24}>
            <AppInput
              name="mobile"
              label="เบอร์โทรศัพท์"
              isRequired={isRequired('mobile')}
              isError={isError('mobile')}
              value={formData.mobile}
              onChange={onUpdateData}
            />
          </Col>
          <Col md={12} xs={24}>
            <AppInput
              label="หมายเหตุ"
              isRequired={isRequired('note')}
              isError={isError('note')}
              name="note"
              value={formData.note}
              onChange={onUpdateData}
            />
          </Col>
          {/* <Col md={12} xs={24}>
            <AppSelect
              name="vat_amount"
              label="ประเภทภาษี"
              isRequired={isRequired('vat_amount')}
              isError={isError('vat_amount')}
              value={formData.vat_amount}
              onChange={onUpdateData}
              menu={menuVatType}
              allowClear={false}
            />
          </Col> */}
        </Row>
      </BoxWrapper>
    )
  }

  return (
    <DetailDrawer
      title={title}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      footer={FooterContent}
      width="70%"
      maskClosable
    >
      <LoadingView isShow={detailEvent.IsLoading} />
      <EventModal event={[event]} enable={true} successCalback={onEventSuccess} errorCalback={clearEvent} />
      <Row justify="space-between" gutter={16}>
        <Col span={24}>{customerInfo()}</Col>
        <Col md={24} xs={24}>
          <ProductsInfo
            detail={detail}
            orderNo={orderNo || ''}
            merchantId={currentUser?.activeMerchant?.id || 0}
            isPublicDelivery={false}
            status={OrderStatus.CANCEL}
            setSelectedGrn={() => {}}
            selectedGrn={[]}
            showSummary={false}
          />
        </Col>
        <Col md={12} xs={24}>
          <br />
          <AppSelect
            name="vat_amount"
            label="ประเภทภาษี"
            isRequired={isRequired('vat_amount')}
            isError={isError('vat_amount')}
            value={formData.vat_amount}
            onChange={onUpdateData}
            menu={menuVatType}
            allowClear={false}
          />
        </Col>
        {/* <Col md={12} xs={24}></Col> */}
        <Col md={8} xs={24}>
          <CustomerSummayTax detail={detail} vat={formData.vat_amount} refundAmount={returnPrice} />
        </Col>
        {/* <Col md={24} xs={24}>
          <DeliveryInfo detail={detail} status={status} />
        </Col>
        <Col md={12} xs={24}>
          <ReciverInfo detail={detail} />
        </Col>
        <Col md={12} xs={24}>
          <PaymentInfo detail={detail} />
        </Col> */}
      </Row>
      {ConfirmCreateDailog}
    </DetailDrawer>
  )
}

const InfoTitle = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectTaxActionEvent(state),
    detail: selectDetail(state),
    detailEvent: selectDetailEvent(state),
    customers: selectAllCustomerTax(state),
    returnList: selectReturnList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(CreateTax)
